<div class="dc-preview-content">
  @if (sanitizedUrl) {
    <div class="dc-preview-frame-wrap">
      <iframe
        #previewFrame
        class="dc-preview-iframe"
        [src]="sanitizedUrl"
        title="Card preview"
      ></iframe>
      @if (showOverlay) {
        <div class="dc-preview-overlay" aria-busy="true">
          <mat-spinner diameter="32"></mat-spinner>
        </div>
      }
    </div>
  } @else {
    <div class="dc-preview-placeholder">
      <mat-spinner diameter="32"></mat-spinner>
      <p class="dc-preview-placeholder__text">
        {{ placeholderText || "Loading preview..." }}
      </p>
    </div>
  }
</div>
